export default "__VITE_ASSET__CS5qA7tK__"